import { render } from "./CloseIcon.vue?vue&type=template&id=4d8742a3&scoped=true"
import script from "./CloseIcon.vue?vue&type=script&lang=js"
export * from "./CloseIcon.vue?vue&type=script&lang=js"

import "./CloseIcon.vue?vue&type=style&index=0&id=4d8742a3&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4d8742a3"]])

export default __exports__